import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const Crumb = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { items } = props;

  const getCrumbKey = text => {
    return text.replace(/\s+/g, '-').toLowerCase();
  };

  const handleClick = (e, link) => {
    e.preventDefault();
    e.stopPropagation();
    if (link) {
      history.push(link);
    }
  };

  return (
    <div className="crumb">
      {items?.map((item, index) => (
        <div className="crumb-item" key={getCrumbKey(item.text)}>
          {index === items.length - 1 ? (
            <span className="crumb-item__text">{item.text}</span>
          ) : (
            <span>
              <a key={index} className="crumb-item__link" onClick={e => handleClick(e, item.link)}>
                {t(item.text)}
              </a>
              <span className="crumb-item__separator">/</span>
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
export default Crumb;
